import { motion } from "framer-motion"

export const ProgressBar = ({ progress, step }: { progress: number; step: number }) => {
  return (
    <div className="progress-wrapper">
      <div className="progress-bg">
        <motion.div
          className="progress-fill"
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] as const }}
        />
      </div>
      <span>{step}/4</span>
    </div>
  )
}